import { z } from "zod";
export const SupportOperationsRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("support-operations-registry.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalSupportOperationsRegistry(recordedAt) {
    return SupportOperationsRegistryV1Schema.parse({
        schemaVersion: "support-operations-registry.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=support-operations-registry.js.map